var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "1 1 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16225"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.707 15H2.293C1.58 15 1 14.42 1 13.707V2.293C1 1.58 1.58 1 2.293 1h7.196a.467.467 0 1 1 0 .933H2.293a.36.36 0 0 0-.36.36v11.414c0 .199.161.36.36.36h11.414a.36.36 0 0 0 .36-.36V6.511a.467.467 0 1 1 .933 0v7.196C15 14.42 14.42 15 13.707 15Z",
    fillRule: "evenodd",
    "data-name": "Path 10827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.364 12.472a.837.837 0 0 1-.822-.988l.413-2.217a.467.467 0 0 1 .129-.245L11.507 1.6a2.05 2.05 0 0 1 2.894 0 2.05 2.05 0 0 1 0 2.894l-7.423 7.422a.467.467 0 0 1-.244.13l-2.217.412a.857.857 0 0 1-.153.014Zm.482-2.893-.36 1.935 1.935-.36 7.32-7.32a1.115 1.115 0 0 0 0-1.575 1.116 1.116 0 0 0-1.575 0l-7.32 7.32Zm9.225-5.415h.005-.005Z",
    fillRule: "evenodd",
    "data-name": "Path 10828"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.cacff9ed1093167e4c2fcf41b6a38ddd.svg";
export { ForwardRef as ReactComponent };